import { useQuery } from "@tanstack/react-query";
import {
  getQualityEventAuditQueryKey,
  getQualityEventDefinitionQueryKey,
  getQualityEventDefinitionsQueryKey,
  getQualityEventDocumentReferencesQueryKey,
  getQualityEventFilesQueryKey,
  getQualityEventRecordQueryKey,
  getQualityEventRecordsQueryKey,
} from "src/config/request-keys";
import {
  getQualityEventAudit,
  getQualityEventDefinition,
  getQualityEventDefinitions,
  getQualityEventDocumentReferences,
  getQualityEventFiles,
  getQualityEventRecord,
  getQualityEventRecords,
} from "src/services/quality-events";

export const useGetQualityEventDefinition = ({
  orgId,
  qualityEventKey,
  enabled = true,
}: {
  orgId: string;
  qualityEventKey: string;
  enabled?: boolean;
}) =>
  useQuery({
    queryKey: getQualityEventDefinitionQueryKey(orgId, qualityEventKey),
    queryFn: async () =>
      await getQualityEventDefinition(orgId, qualityEventKey),
    enabled: enabled && !!orgId && !!qualityEventKey,
  });

export const useGetQualityEventDefinitions = ({
  orgId,
  enabled = true,
}: {
  orgId: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: getQualityEventDefinitionsQueryKey(orgId),
    queryFn: async () => await getQualityEventDefinitions(orgId),
    enabled: enabled && !!orgId,
  });
};

export const useGetQualityEventRecords = ({
  orgId,
  qualityEventKey,
  enabled = true,
}: {
  orgId: string;
  qualityEventKey: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: getQualityEventRecordsQueryKey(orgId, qualityEventKey),
    queryFn: async () => await getQualityEventRecords(orgId, qualityEventKey),
    enabled: enabled && !!orgId && !!qualityEventKey,
  });
};

export const useGetQualityEventRecord = ({
  orgId,
  recordId,
  enabled = true,
}: {
  orgId: string;
  recordId: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: getQualityEventRecordQueryKey(orgId, recordId),
    queryFn: async () => await getQualityEventRecord(orgId, recordId),
    enabled: enabled && !!orgId && !!recordId,
  });
};

export const useGetQualityEventAudit = ({
  orgId,
  recordId,
  enabled = true,
}: {
  orgId: string;
  recordId: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: getQualityEventAuditQueryKey(orgId, recordId),
    queryFn: async () => await getQualityEventAudit(orgId, recordId),
    enabled: enabled && !!orgId && !!recordId,
  });
};

export const useGetQualityEventFiles = ({
  orgId,
  enabled = true,
}: {
  orgId: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: getQualityEventFilesQueryKey(orgId),
    queryFn: async () => await getQualityEventFiles(orgId),
    enabled: enabled && !!orgId,
  });
};

export const useGetQualityEventDocumentReferences = ({
  orgId,
  enabled = true,
}: {
  orgId: string;
  enabled?: boolean;
}) =>
  useQuery({
    queryKey: getQualityEventDocumentReferencesQueryKey(orgId),
    queryFn: async () => await getQualityEventDocumentReferences(orgId),
    enabled: enabled && !!orgId,
  });
